import { render, staticRenderFns } from "./VentanaOperacionesSeguimientoViaje.vue?vue&type=template&id=efc594dc"
import script from "./VentanaOperacionesSeguimientoViaje.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesSeguimientoViaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports